<template>
	<el-select remote-show-suffix clearable filterable :style="{'width': `${width}`}" :disabled="disabled" :size="size"
		v-model="UnitId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder"
		@change="UnitChange" @clear="UnitClear">
		<el-option v-for="v in UnitList" :key="v.value" :label="v[LabelKey]" :value="v[ValueKey]" />
	</el-select>
</template>

<script lang="ts" setup>
	import { ref, getCurrentInstance, defineEmits, defineProps, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	};

	const props = withDefaults(defineProps<main>(), {
		id: "",
		size: "default",
		ValueKey: "label",
		LabelKey: "label",
		width: "100%",
		disabled: false,
		IsAuto: false,
	});

	const { proxy } = getCurrentInstance() as any;
	const emits = defineEmits(["update:id", "change", "clear"]);
	const UnitId = ref<any>("");
	const UnitList = ref<any>([]);
	const loading = ref(false);
	const placeholder = ref("请选择单位");

	watch(() => props.id, (n : any) => {
		UnitId.value = n;
	});

	onMounted(() => {
		UnitId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshUnit) {
				GetData();
			} else {
				if (proxy.$store.state.UnitList.length > 0) {
					UnitList.value = proxy.$store.state.UnitList;
				} else {
					GetData();
				}
			}
		}
	});

	const UnitChange = (data : any) => {
		console.log(data)
		emits("update:id", data);
		emits("change", data);
	};
	const UnitClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshUnit) {
			GetData();
		} else {
			if (proxy.$store.state.UnitList.length > 0) {
				UnitList.value = proxy.$store.state.UnitList;
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		proxy.$api.tokenRequest({
			url: '/admin/type',
			data: {
				type: 3,
				is_page: 0
			},
			success: (res : any) => {
				UnitList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 19,
					data: res.data,
				});
			},
		});
	}
</script>

<style>
</style>